import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=27ffcd07&"
import script from "./CustomerEditor.vue?vue&type=script&lang=js&"
export * from "./CustomerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports